/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const COLORS = [
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#FF0000",
  "#8C00AE",
  "#4D2517",
  "#000468",
  "#0B4000",
  "#820002",
];

export const pieChartStyle = { background: "#ebebeb", padding: "20px" };

export const noDataStyle = { width: "400px", height: "300px" };
